module.exports = __webpack_public_path__ + "1fa9bde26bf9384cc42d97ace3bca023.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-14.png
// module id = 2997
// module chunks = 0